import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
} from '@angular/core';
import {
  IonIcon,
  IonLabel,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from '@ionic/angular/standalone';
import { Store } from '@ngxs/store';

import { RoutingService } from '@shared/services/routing.service';
import { Icons } from '@icons';
import { RoutingPath } from '@shared/enums/routing-path.enum';
import { UserState } from '@user/store/user.state';
import {
  StatisticsActions,
} from '@shared/statistics/store/statistics.actions';
import { StatisticPayload } from '@shared/statistics/models/statistic.model';
import { StatisticType } from '@shared/statistics/enums/statistic-type.enum';

interface TabItem {
  href: string;
  i18n: string;
  icon: string;
  label: string;
  name: string;
}

@Component({
  selector: 'app-auth',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonIcon,
    IonLabel,
  ],
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent {

  private _store = inject(Store);

  private _user = this._store.selectSignal(UserState.getUser);

  constructor() {
    effect(() => this._trackUserAccess());
  }

  protected tabs: TabItem[] = [
    {
      href: RoutingService.HOME,
      name: RoutingPath.HOME,
      icon: Icons.IC_HOME,
      i18n: '@@tabs.home',
      label: 'Início',
    },
    {
      href: RoutingService.DEVELOPMENTS,
      name: RoutingPath.DEVELOPMENTS,
      icon: Icons.IC_BUILDING,
      i18n: '@@tabs.developments',
      label: 'Empreendimentos',
    },
    {
      href: RoutingService.FAVORITES,
      name: RoutingPath.FAVORITES,
      icon: Icons.IC_HEART,
      i18n: '@@tabs.favorites',
      label: 'Favoritos',
    },
    {
      href: RoutingService.CONFIGS,
      name: RoutingPath.CONFIGS,
      icon: Icons.IC_SETTINGS,
      i18n: '@@tabs.configs',
      label: 'Configurações',
    },
  ];

  private _trackUserAccess() {
    const user = this._user();
    if (!user) {
      return;
    }

    const names: string[] = [];
    if (user.name) {
      names.push(user.name);
    }
    if (user.realEstate) {
      names.push(user.realEstate);
    }

    for (const name of names) {
      const payload = new StatisticPayload({
        type: StatisticType.CUSTOMERS,
        code: user.creci,
        name,
        region: user.regionId ?? '',
      });
      this._store.dispatch(new StatisticsActions.Track(payload));
    }

  }
}
